import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../services/api';
import './Auth.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await authAPI.forgotPassword({ email });
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-background">
        <div className="auth-orb auth-orb-1"></div>
        <div className="auth-orb auth-orb-2"></div>
        <div className="auth-orb auth-orb-3"></div>
      </div>

      <div className="auth-card">
        <div className="auth-logo">
          <img src="/logo.svg" alt="EchoMemoir" style={{ width: '80px', height: '80px' }} />
          <h1>EchoMemoir</h1>
        </div>

        {success ? (
          <div className="auth-form">
            <h2>Check Your Email</h2>
            <div className="auth-success">
              <p>If an account exists with <strong>{email}</strong>, we've sent a password reset link.</p>
              <p>Check your inbox (and spam folder) and follow the link to reset your password.</p>
            </div>
            <Link to="/login" className="auth-button" style={{ textDecoration: 'none', textAlign: 'center' }}>
              Back to Sign In
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="auth-form">
            <h2>Forgot Password</h2>
            <p className="auth-subtitle">Enter your email and we'll send you a reset link.</p>

            {error && <div className="auth-error">{error}</div>}

            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
                autoFocus
              />
            </div>

            <button type="submit" className="auth-button" disabled={loading}>
              {loading ? <span className="spinner"></span> : 'Send Reset Link'}
            </button>

            <p className="auth-switch">
              Remember your password? <Link to="/login">Sign in</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;